import { SNAPSHOTS_URL, snapshotNetworkUrl } from '../services/snapshotNetworks';
import type { SnapshotNetwork } from '../services/snapshotNetworks';

const TOOLS = [
  {
    title: 'Node snapshots',
    text: 'Pruned and archive snapshots of the chains we run, taken on a schedule and with restore steps for each chain, so a new node syncs in minutes instead of days.',
  },
  {
    title: 'Seed nodes and live peers',
    text: 'Seed nodes, peers verified by handshake and a fresh addrbook.json, refreshed every 10 minutes.',
  },
  {
    title: 'Network maps',
    text: "Where each network's nodes run: countries, hosting providers and node versions, from peers we re-check every hour.",
  },
];

// Laid out on the same grid as the networks above, so its content lines up with the network cards.
export default function NodeOperators({ networks }: { networks: SnapshotNetwork[] }) {
  return (
    <section id='NodeOperators' className='node-operators grid grid-cols-1 lg:grid-cols-3 gap-4 py-16 lg:py-24'>
      <div className='col-span-2 lg:col-start-2 px-5 lg:px-0 lg:pr-10'>
        <div className='flex flex-col xl:flex-row'>
          <h2 className='flex justify-start p-sub-yellow'>For Node Operators</h2>
          <p className='flex justify-start p-sub-grey hidden-component'>Free from Kingnodes</p>
        </div>
        <p className='text-left p1-gray pt-5'>
          The infrastructure behind our validators is open to anyone running a node on the networks we support.
        </p>
        <div className='grid grid-cols-1 lg:grid-cols-3 gap-10 py-10'>
          {TOOLS.map((tool) => (
            <div key={tool.title}>
              <h3 className='card-title-1 text-left pb-3'>{tool.title}</h3>
              <p className='card-description text-left'>{tool.text}</p>
            </div>
          ))}
        </div>
        {networks.length > 0 && (
          <p className='text-left p1-gray pb-8'>
            {/* Only snapshots: not every chain here has a seed node (Sei doesn't). */}
            Snapshots for{' '}
            {networks.map((network, i) => (
              <span key={network.slug}>
                {i > 0 && (i === networks.length - 1 ? ' and ' : ', ')}
                <a className='text-link' href={snapshotNetworkUrl(network)}>
                  {network.name}
                </a>
              </span>
            ))}
            .
          </p>
        )}
        <a className='button-link' href={SNAPSHOTS_URL}>
          Browse all snapshots
        </a>
      </div>
    </section>
  );
}
